module.exports = MINT;


//////////////////
// WEBPACK FOOTER
// external "MINT"
// module id = Tg7E
// module chunks = 1